import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ResourceService } from 'src/app/services/resource/resource.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


@Component({
  selector: 'app-knowledge-base',
  templateUrl: './knowledge-base.component.html',
  styleUrls: ['./knowledge-base.component.css']
})
export class KnowledgeBaseComponent implements OnInit {


  Submitted: boolean = false;
  KnowledgeBaseList: any;


  constructor(private resourceService: ResourceService, private LookupService: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService,
    private _sanitizer: DomSanitizer) { }


  ResourceModel = {
    KBID: 0,
    ParentID: 0,
    KBTitle: '',
    DisplayOrder:0,
    FriendlyURL: '',
    IsPublish: false,
    MetaKeywords:'',
    ShortDescription:'',
  };
  Content = '';
  ClearKB() {
    this.Submitted = false;
    this.ResourceModel.KBTitle = '';
    this.ResourceModel.FriendlyURL = '';
    this.ResourceModel.ShortDescription = '';
    this.ResourceModel.MetaKeywords = '';
    this.ResourceModel.KBID = 0;
    this.ResourceModel.ParentID = 0;
    this.ResourceModel.DisplayOrder=0;
    this.ResourceModel.IsPublish = false;
    this.Content = '';
  };

  SaveKnowledgeBase(valid) {
    this.Submitted = true;
    if (valid) {
      this.spinnerService.show();
      this.resourceService.SaveKnowledgeBase(JSON.stringify(this.ResourceModel), this.Content).subscribe((data: any) => {

        this.spinnerService.hide();
        if (data.webResponse.Status && this.ResourceModel.KBID == 0) {
          this.ClearKB();
        }
        if (data.webResponse.Status) {
          this.GetAllKnowledgeBase();
          this.BindParent();
        }
        this.globalHelper.CheckActionStatus(data);

      });
    }
  }

  SearchModel = {
    ResourceType: '0'
  }

  GetAllKnowledgeBase() {
    this.resourceService.GetAllKnowledgeBase(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
      this.KnowledgeBaseList = data.KnowledgeBaseList;
    });

  }

  EditKnowledgeBase(obj) {
    this.ResourceModel.KBTitle = obj.KBTitle;
    this.ResourceModel.KBID = obj.KBID;
    this.ResourceModel.ParentID = obj.ParentID;
    this.Content = obj.KBDescription
    this.ResourceModel.IsPublish = obj.IsPublish;
    this.ResourceModel.DisplayOrder=obj.DisplayOrder;
    this.ResourceModel.ShortDescription=obj.ShortDescription;
    this.ResourceModel.MetaKeywords=obj.MetaKeywords;

  };

  ngOnInit() {
    if (window.history.state.KBDetails != undefined) {
      this.EditKnowledgeBase(window.history.state.KBDetails);
    }
    this.BindParent();
    this.GetAllKnowledgeBase();
  }

  Parent = [];
  BindParent() {
    this.LookupService.GetLookupsList('ParentKB', '').subscribe((data: any) => {
      this.Parent = data.LookupItems;
    });
  }

  // Resource

  tab = 1;

  setTab(tabId) {
    this.Clipboard = false;
    this.tab = tabId;
  };

  
  PDFResourceList = [];
  ImageResourceList = [];
  VideoResourceList = [];
  YoutubeResourceList = [];
  GetKnowldegeResource() {
    this.spinnerService.show();
    this.resourceService.GetKnowldegeResource(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
      this.PDFResourceList = data.PDFResourceList;
      this.ImageResourceList = data.ImageResourceList;
      this.VideoResourceList = data.VideoResourceList;
      this.YoutubeResourceList = data.YoutubeResourceList;      
      if (this.YoutubeResourceList != null) {
        for (var i = 0; i < this.YoutubeResourceList.length; i++) {
          this.YoutubeResourceList[i].YouTubeUrls = this._sanitizer.bypassSecurityTrustResourceUrl(this.YoutubeResourceList[i].YouTubeUrls);
        }
      }
    
      this.spinnerService.hide();
    });

  }

  Clipboard = false;
  copyInputMessage(inputElement) {
    this.Clipboard = true;
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
  }

  

}


